import { render } from "./MatchDetailsView.vue?vue&type=template&id=0e0fd8f7&scoped=true"
import script from "./MatchDetailsView.vue?vue&type=script&lang=js"
export * from "./MatchDetailsView.vue?vue&type=script&lang=js"

import "./MatchDetailsView.vue?vue&type=style&index=0&id=0e0fd8f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0fd8f7"]])

export default __exports__